import { forwardRef, memo, useCallback, useMemo } from 'react';
import { Container, Dropdown, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { toastConfig } from '../../redux/actions/toast';
import { WATCHLIST_GRID_REF, deepClone, getDecryptLocalStorage, handleGridRowDragOnAndOff, handleSelectColumns, handleToggleColumnsVisible, isUserIsAGuest, returnCountWithPad, updateGridColumnDef, updateGridRowSlectionType } from '../../utils/global_functions';
import { FACILITY_NUM, LOCAL_STORAGE_KEYS, MANAGE_COLUMNS_VIEW_TYPES, WATCHLIST_GRID_INDEX, WATCHLIST_TABS_MENUS, GRID_VIEW, GRID_SELECT_TYPE, GRID_ROW_SELECTION_TYPE, DEFAULT_MANAGE_COLUMN_PROFILE_NAME } from '../../utils/global_variables';
import { _handleSystemDefinedWatchlist, _isWatchlistSystemDefined } from "../../controllers";
import { selectScripForDelete, updateDefaultManageColumnName, updateStrViewType } from '../../redux/actions/watchlist';
import { isGuestUser } from '../../utils/global_functions';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
import GridHeaderCheckbox from '../GridHeaderCheckbox';

const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));



const TabsMenus = ({
    sortedColumnDef,
    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -reordering scrips fix when filtered  – Start **Do not change the code
    filteredRows, setMenusClicked, isFilterDataPresent = 'true',
    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -reordering scrips fix when filtered  – End **Do not change the code
    openWatchlists, handleAllFunctions, setIsToastToggle, dontMissOrHoldingsIdCheck, activeWatchList, children, handleWatchlistViewChange, setBIsShowDeleteCheckBox, setBIsShowSortHandle, strSearchScrip, ...props }) => {
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    const strWatchlistView = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.WATCHLIST_VIEW);
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const arrWatchlistKababDropdown = useMemo(() => [strWatchlistView === GRID_VIEW.DEFAULT_VIEW && { id: '0', value: WATCHLIST_TABS_MENUS.MANAGE_COLUMNS, content: 'Manage columns', shortcut: 'Shift + V' },
    (strWatchlistView === GRID_VIEW.DEFAULT_VIEW || strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) && { id: '1', value: WATCHLIST_TABS_MENUS.ADD_SCRIPS, content: 'Add scrips' },//Hari k : 02-04-2022 : BT-95888 - Breeze - Create Watchlist - to hide this option in heat map view
    // strWatchlistView === GRID_VIEW.DEFAULT_VIEW && { id: '2', value: WATCHLIST_TABS_MENUS.EXPORT_TO_EXCEL, content: 'Export to excel' },
    //  strWatchlistView === GRID_VIEW.DEFAULT_VIEW && { id: '3', value: WATCHLIST_TABS_MENUS.LINK_TO_EXCEL, content: 'Link to excel' }, // Will be coming in next phase of breeze
    (strWatchlistView === GRID_VIEW.DEFAULT_VIEW || strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) && { id: '4', value: WATCHLIST_TABS_MENUS.REMOVE_SCRIPS, content: 'Remove scrips' }, //Hari k : 02-04-2022 : BT-95888 - Breeze - Create Watchlist - to hide this option in heat map view
    (strWatchlistView === GRID_VIEW.DEFAULT_VIEW || strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) && { id: '5', value: WATCHLIST_TABS_MENUS.REORDER_SCRIPS, content: 'Reorder scrips' }, //Hari k : 02-04-2022 : BT-95888 - Breeze - Create Watchlist - to hide this option in heat map view
    { id: '6', value: WATCHLIST_TABS_MENUS.RENAME_WATCHLIST, content: 'Rename watchlist' },
    { id: '7', value: WATCHLIST_TABS_MENUS.SET_DEFAULT, content: 'Set default' },
    (strWatchlistView === GRID_VIEW.DEFAULT_VIEW || strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) && { id: '8', value: WATCHLIST_TABS_MENUS.SHARE_WATCHLIST, content: 'Share/Download Watchlist' }, //Hari k : 02-04-2022 : BT-95888 - Breeze - Create Watchlist - to hide this option in heat map view
    { id: '9', value: WATCHLIST_TABS_MENUS.CREATE_NEW_WATCHLIST, content: 'Create new watchlist', shortcut: 'Alt + N' },//Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - issue changed ctrl to Alt
    { id: '10', value: WATCHLIST_TABS_MENUS.DELETE_WATCHLIST, content: 'Delete watchlist', shortcut: 'Ctrl + Delete' },
    { id: '11', value: WATCHLIST_TABS_MENUS.DEFAULT_VIEW, content: 'Default view' },
    { id: '12', value: WATCHLIST_TABS_MENUS.PRICE_VOLUME_VIEW, content: GRID_VIEW.PRICE_VOLUME_VIEW },
    // Vinit R [19-07-2024] - Hide heatmap view - Start 
    // { id: '13', value: WATCHLIST_TABS_MENUS.HEATMAP, content: 'Heatmap view' },
    // Vinit R [19-07-2024] - Hide heatmap viewp - End 
    ((strWatchlistView === GRID_VIEW.DEFAULT_VIEW || strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) && (objCFT.BULKORDER === FACILITY_NUM.ON)) && { id: '14', value: WATCHLIST_TABS_MENUS.CONVERTTOORDERCART, content: 'Convert To OrderCart' }, //Hari k : 02-04-2022 : BT-95888 - Breeze - Create Watchlist - to hide this option in heat map view
    //BT-106965 : OrderCart : ManasaB : 19/01/2024 : Unit testing bugs resolve
    (strWatchlistView === GRID_VIEW.DEFAULT_VIEW) && { id: WATCHLIST_TABS_MENUS.CLEAR_GRID_FILTER, value: WATCHLIST_TABS_MENUS.CLEAR_GRID_FILTER, content: 'Reset Filters' },
    ], [strWatchlistView]);

    const dispatch = useDispatch();
    const getEvent = useAnalyticsEventTracker('WATCHLIST');
    const watchlistKababaDropdownOnClickHandler = useCallback((e, value) => {

        switch (value) {
            case WATCHLIST_TABS_MENUS.DEFAULT_VIEW: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                handleWatchlistViewChange(GRID_VIEW.DEFAULT_VIEW);
                break;
            }
            case WATCHLIST_TABS_MENUS.BLOCK_VIEW: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                break;
            }
            case WATCHLIST_TABS_MENUS.HEATMAP: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                // Vinit R [19-07-2024] - Hide heatmap view - Start 
                // handleWatchlistViewChange(GRID_VIEW.HEAT_MAP);
                // Vinit R [19-07-2024] - Hide heatmap view - End 
                break;
            }
            // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
            case WATCHLIST_TABS_MENUS.PRICE_VOLUME_VIEW: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                handleWatchlistViewChange(GRID_VIEW.PRICE_VOLUME_VIEW);
                break;
            }
            // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 

            case WATCHLIST_TABS_MENUS.MANAGE_COLUMNS: {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.WATCHLIST))
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE));
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "MANAGE_COLUMNS");
                if (!isWatchlistSystemDefined.status) {
                    setTimeout(() => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined.message }));
                    }, 200);
                } else {
                    dispatch(handleModal([{ 'WATCHLIST_MANAGE_COLUMNS_MODAL': true }]));
                }

                break;
            }
            case WATCHLIST_TABS_MENUS.ADD_SCRIPS: {
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "ADD");
                if (!isWatchlistSystemDefined?.status) {
                    setTimeout(() => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Cannot add scrips to system defined watchlists' }));
                    }, 50);
                } else {
                    dispatch(handleModal([{ 'ADD_SCRIPT_ACTIVE_WATCHLIST_MODAL': true }]));

                }
                break;
            }
            case WATCHLIST_TABS_MENUS.REMOVE_SCRIPS: {
                getEvent("DELETE_SCRIP_WL");
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);

                let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "REMOVE");
                if (!isWatchlistSystemDefined?.status) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined.message }));
                } else {
                    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
                    if (strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) {
                        let filteredScrips = [];

                        if (strSearchScrip?.length > 0) {
                            filteredScrips = activeWatchList['scrips']?.filter((item) => item[WATCHLIST_GRID_INDEX.SYMBOL]?.toUpperCase()?.includes(strSearchScrip?.toUpperCase()));
                            dispatch(selectScripForDelete(filteredScrips));
                        } else {
                            filteredScrips = activeWatchList['scrips'];
                            dispatch(selectScripForDelete(filteredScrips));
                        }
                        dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> {returnCountWithPad(filteredScrips?.length)}</div> {filteredScrips?.length === 1 ? 'scrip' : 'scrips'} from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));
                        setBIsShowDeleteCheckBox(true);
                    } else {
                        // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
                        // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue - selecting only filtered scrips  – Start
                        setMenusClicked(prevState => { return { isReorder: false, isRemoveScrips: true }; });
                        WATCHLIST_GRID_REF.current.api.setGridOption('rowDrag', false);
                        let arrColumnsNode = WATCHLIST_GRID_REF?.current?.api?.getColumnDefs()
                        const nIndex = arrColumnsNode?.findIndex(elem => elem?.colId === 'check');
                        if (nIndex >= 0) {
                            arrColumnsNode[nIndex] = {
                                colId: "check",
                                hide: false,
                                headerComponent: GridHeaderCheckbox,
                                headerCheckboxSelection: true,
                                checkboxSelection: true,
                                showDisabledCheckboxes: true,
                                pinned: 'left',
                                suppressNavigable: true,
                                suppressMovable: true,
                                lockPosition: "left",
                                width: '40'
                            };
                        } else { }

                        setTimeout(() => {
                            updateGridColumnDef(WATCHLIST_GRID_REF, [...arrColumnsNode]);
                            updateGridRowSlectionType(WATCHLIST_GRID_REF, GRID_ROW_SELECTION_TYPE.MULTI_ROW);
                            // handleSelectColumns(WATCHLIST_GRID_REF,'all',GRID_SELECT_TYPE.SELECT)
                        }, 500);
                        setIsToastToggle(true);
                        dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'>{returnCountWithPad(WATCHLIST_GRID_REF?.current?.api.getSelectedRows().length)}</div> {WATCHLIST_GRID_REF?.current?.api.getSelectedRows().length === 1 ? 'scrip' : 'scrips'} from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: 'btn  btn-outline-active ms-3' }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: 'btn  btn-solid ms-3' }] }));
                    }

                }
                break;
            }
            case WATCHLIST_TABS_MENUS.REORDER_SCRIPS: {
                getEvent("REORDER_WL");
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                setTimeout(() => {
                    dispatch(toastConfig({}));
                }, 50);
                let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "REORDER");
                if (!isWatchlistSystemDefined?.status) {
                    setTimeout(() => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined.message }));
                    }, 50);
                } else {
                    if (strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) {
                        if (activeWatchList?.scrips?.length === 1) {
                            setTimeout(() => {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Add one more scrip to reorder`, }));
                            }, 50);

                        } else {
                            setBIsShowSortHandle(true);
                            setTimeout(() => {
                                dispatch(toastConfig({ show: true, message: `Reorder Scrips in '${activeWatchList?.sWatchListName}'`, button: [{ btnName: "Cancel", type: "CANCEL_REORDERING_SCRIPS", className: "btn btn-outline-active" }, { btnName: "Done", type: "UPDATE_REORDERING_SCRIPS", className: "btn btn-solid ms-3" }] }));
                            }, 50);
                        }

                    } else {

                        let arrCurrColumnDefs = WATCHLIST_GRID_REF?.current?.api?.getColumnDefs();
                        const objRowDragColumn = arrCurrColumnDefs.find(column => column.field === WATCHLIST_GRID_INDEX.SYMBOL.toString());
                        if (activeWatchList?.scrips?.length === 1) {
                            setTimeout(() => {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Add one more scrip to reorder`, }));
                            }, 50);

                        } else {
                            if (objRowDragColumn) {
                                setMenusClicked(prevState => { return { ...prevState, isReorder: true }; });
                                // Vinit R : 28-02-24 : BT-109055 : Price/Volume view -- Start
                                setTimeout(() => {
                                    handleGridRowDragOnAndOff(WATCHLIST_GRID_REF, WATCHLIST_GRID_INDEX?.SYMBOL?.toString(), true);
                                    WATCHLIST_GRID_REF?.current?.api.forEachNode((node) => {
                                        node.setSelected(false);
                                    });
                                    handleToggleColumnsVisible(WATCHLIST_GRID_REF, 'check', true);
                                    dispatch(toastConfig({ show: true, message: `Reorder scrips in '${activeWatchList?.sWatchListName}'`, button: [{ btnName: "Cancel", type: "CANCEL_REORDERING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Done", type: "UPDATE_REORDERING_SCRIPS", className: "btn btn-solid ms-3" }] }));
                                }, 50);
                                // Vinit R : 28-02-24 : BT-109055 : Price/Volume view -- End
                            } else { }
                        }

                    }
                }
                break;
            }
            case WATCHLIST_TABS_MENUS.RENAME_WATCHLIST: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);

                let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "RENAME");
                if (!isWatchlistSystemDefined.status) {
                    setTimeout(() => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined.message }));
                    }, 50);
                } else {
                    dispatch(handleModal([{ "RENAME_MODAL": true }]));
                }
                break;
            } case WATCHLIST_TABS_MENUS.CREATE_NEW_WATCHLIST: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                handleAllFunctions("HANDLE_CREATE_NEWWATCHLIST_OPTION");
                break;
            } case WATCHLIST_TABS_MENUS.SHARE_WATCHLIST: {
                if (!isUserIsAGuest('shareWatchlist')) {
                    handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                    handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                    dispatch(handleModal([{ 'WATCHLIST_SHARE_MODAL': true }]));
                } else { }
                break;
            }
            case WATCHLIST_TABS_MENUS.EXPORT_TO_EXCEL: {
                handleAllFunctions('EXPORT_DATA_EXCEL');
                break;
            } case WATCHLIST_TABS_MENUS.LINK_TO_EXCEL: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
                break;
            }
            case WATCHLIST_TABS_MENUS.SET_DEFAULT: {
                handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);

                handleAllFunctions('SET_DEFAULT', deepClone(activeWatchList), e, false);



                break;
            }
            case WATCHLIST_TABS_MENUS.DELETE_WATCHLIST: {
                getEvent("DELETE_WL");
                handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);

                if (activeWatchList?.bIsDefault) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Cannot delete default watchlist' }));
                } else {
                    let isWatchlistSystemDefined = _handleSystemDefinedWatchlist(activeWatchList, "DELETE");
                    if (!isWatchlistSystemDefined.status) {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistSystemDefined.message }));
                    } else {
                        handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
                        handleAllFunctions('DELETE_WATCHLIST', activeWatchList, e);
                    }

                }
                break;

            }
            //BT-106965 : OrderCart  : ManasaB : 22/01/2024 : Unit testing bugs resolve - Start
            case WATCHLIST_TABS_MENUS.CONVERTTOORDERCART: {
                const arrFilteredscrips = activeWatchList?.scrips?.filter(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.INSTRUMENT] === 'EQUITIES');
                if (arrFilteredscrips?.length > 0) {
                    if (!isUserIsAGuest('Order_Cart')) {
                        handleAllFunctions('CONVERT_TO_ORDER_CART', WATCHLIST_GRID_REF);
                    } else { }
                } else { }

                break;
            }
            case WATCHLIST_TABS_MENUS?.CLEAR_GRID_FILTER: {
                WATCHLIST_GRID_REF?.current?.api.setFilterModel(null);
                break;
            }
            //BT-106965 : OrderCart  : ManasaB : 22/01/2024 : Unit testing bugs resolve - End
            default: ;
        }
    }, [activeWatchList, handleAllFunctions, setMenusClicked, isFilterDataPresent, setBIsShowSortHandle, setIsToastToggle, dispatch, strWatchlistView,
        handleWatchlistViewChange,
        setBIsShowDeleteCheckBox]);

    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -disabling when filtered data to avaoid reorder – Start **Do not change the code
    const isDisable = useCallback((eachOption) => {
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To disable Convert To Order Cart Button - Start
        const arrFilteredscrips = activeWatchList?.scrips?.filter(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.INSTRUMENT] === 'EQUITIES');
        const value = eachOption?.id === '5' && filteredRows?.length > 0 ? true : false
            // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
            || (eachOption?.id === '5' && strSearchScrip?.length > 0) ? true : false
                || (eachOption?.id === '14' && arrFilteredscrips?.length === 0) ? true : false;
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To disable Convert To Order Cart Button - End
        // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
        return value;
    }, [activeWatchList, filteredRows, strSearchScrip]);
    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -disabling when filtered data to avaoid reorder – Start **Do not change the code


    const isWatchlistSystemDefined = _isWatchlistSystemDefined(activeWatchList)?.status;

    const filteredKebabDropdown = useMemo(() => {
        if (isWatchlistSystemDefined) {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict Guest User - Start
            if (isGuestUser()) {
                return arrWatchlistKababDropdown?.filter(eachOption => eachOption?.id !== WATCHLIST_TABS_MENUS.CONVERTTOORDERCART);
            }
            else {
                return arrWatchlistKababDropdown;
            }
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict Guest User - End
        } else {
            //need to return filtered options
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 : To restrict Guest User - Start
            if (isGuestUser()) {
                return arrWatchlistKababDropdown?.filter(eachOption => eachOption?.id !== "8" && eachOption?.id !== WATCHLIST_TABS_MENUS.CONVERTTOORDERCART);
            }
            else {
                return arrWatchlistKababDropdown?.filter(eachOption => eachOption?.id !== "8");
            }
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 : To restrict Guest User - End
        }
    }, [isWatchlistSystemDefined, arrWatchlistKababDropdown]);

    return (
        <Dropdown className='dropdown-kebab'>
            <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                {children}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    filteredKebabDropdown?.length && filteredKebabDropdown?.filter((each) => each !== false)?.map((eachOption) => (

                        <Dropdown.Item
                            // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -disabling when filtered data to avoid reorder – Start **Do not change the code
                            className={`${isDisable(eachOption) ? 'text-disabled' : ''}`}
                            // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -disabling when filtered data to avoid reorder  – End **Do not change the code
                            key={eachOption.id} value={eachOption.value} onClick={(e) => watchlistKababaDropdownOnClickHandler(e, eachOption.value)}>
                            <Container fluid className='p-0'>
                                <Row className='g-0'>
                                    <Col md={eachOption?.shortcut ? 12 : 12} className={`d-flex justify-content-between `}>

                                        <span className='text-nowrap text-truncated'>{eachOption?.content}</span>

                                        <div className='d-flex justify-content-end'>
                                            {strWatchlistView === eachOption?.content &&
                                                <div className='icon-20 icon-checktick icon-primary'></div>
                                            }
                                            {
                                                eachOption?.shortcut &&
                                                <span className='d-flex justify-content-end align-self-center'>
                                                    {eachOption?.shortcut}
                                                </span>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Dropdown.Item>
                    ))
                }
            </Dropdown.Menu>
        </Dropdown>
    );
};


export default memo(TabsMenus);